const IOS_DEVICE_PATTERN = /iPad|iPhone|iPod/
const SAFARI_TOKEN_PATTERN = /Safari\//
const NON_WEBKIT_ENGINE_PATTERN = /Chrome\/|Chromium\/|Edg\/|Android/

/**
 * True for desktop Safari and for every browser on iOS, which Apple
 * requires to run on WebKit. They share the behaviour this guards
 * against: an object element embedding a PDF does not follow a
 * cross-origin redirect.
 *
 * Two independent signals, ORed:
 *
 * - GestureEvent on window, implemented only by WebKit. The primary
 *   check, and the one that holds when a user agent string changes.
 * - A user agent match, as the fallback for GestureEvent ever being
 *   removed.
 *
 * Losing either signal on its own does not break detection.
 *
 * This can be removed if WebKit's object element ever follows the
 * redirect. To check, point an object element at a URL that redirects
 * to another origin in Safari and see whether the PDF renders.
 */
export const isWebKitBrowser = (userAgent: string): boolean => {
  if ('GestureEvent' in window) {
    return true
  }

  if (IOS_DEVICE_PATTERN.test(userAgent)) {
    return true
  }

  return (
    SAFARI_TOKEN_PATTERN.test(userAgent) &&
    !NON_WEBKIT_ENGINE_PATTERN.test(userAgent)
  )
}
